import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { WorkerStatus } from '@api/models/enums/WorkerStatus';

interface Props {
  value?: WorkerStatus[];
  onChange: (value?: WorkerStatus[]) => void;
}

export const GridFilterInvitationWorkerStatus: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = Object.values(WorkerStatus);

  return (
    <GridFilterSelectMultiple
      value={value ?? []}
      options={options}
      onChange={onChange}
      getOptionId={(option: WorkerStatus) => option}
      getOptionName={(option: WorkerStatus) =>
        t(`invitation.workerStatus.${option}`)
      }
    />
  );
};
